import { __rest } from "tslib";
var notificationId = 1;
export function makeNotification(type, queueName, params) {
    if (params && params.hasOwnProperty('id')) {
        var id = params.id, rest = __rest(params, ["id"]);
        return { id: id, queueName: queueName, type: type, created: Date.now(), params: rest };
    }
    return {
        id: notificationId++,
        queueName: queueName,
        type: type,
        created: Date.now(),
        params: params,
    };
}
//# sourceMappingURL=makeNotification.js.map